import { Role } from '@infiltre/shared';
import { SoundCue } from '@/shared/lib/audio';

/** Returns the win-fanfare cue for the round winner, or `null` if no audio applies. */
export const resolveWinSound = (winner: Role | null): SoundCue | null => {
  if (winner === Role.Infiltre) return SoundCue.GameWonInfiltre;
  if (winner === Role.Clochard) return SoundCue.GameWonClochard;
  if (winner === Role.Flic) return SoundCue.GameWonFlic;
  return null;
};
